import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { AiFillEdit } from "react-icons/ai";
import api from "../../services/api";

const defaultModules = [
  // Menú principal: Carga de datos
  { name: "Carga de datos", key: "carga-datos", isMain: true },
    { name: "Personas", key: "add-persona", parent: "carga-datos" },
    { name: "Casos", key: "casos", parent: "carga-datos" },
    { name: "Contactos", key: "add-contactos", parent: "carga-datos" },
    { name: "Países", key: "add-pais", parent: "carga-datos" },
    { name: "Tipo de documentos", key: "add-tipo-documento", parent: "carga-datos" },
    { name: "Tipos de domicilio", key: "add-tipo-domicilio", parent: "carga-datos" },
    { name: "Estados", key: "add-estado", parent: "carga-datos" },
    { name: "Patologías", key: "add-patologia", parent: "carga-datos" },
    { name: "Síntomas", key: "add-sintomas", parent: "carga-datos" },
    { name: "Comorbilidades", key: "add-comorbilidad", parent: "carga-datos" },
    { name: "Estados por patologías", key: "add-estado-por-patologia", parent: "carga-datos" },
    { name: "Síntomas por patologías", key: "add-sintoma-por-patologia", parent: "carga-datos" },
    { name: "Comorbilidades por patologías", key: "add-comorbilidad-por-patologia", parent: "carga-datos" },
    { name: "Estudios", key: "add-estudios", parent: "carga-datos" },
    { name: "Estudios por patologías", key: "add-estudio-por-patologia", parent: "carga-datos" },
    { name: "Atributos", key: "add-atributos", parent: "carga-datos" },
    { name: "Atributos por patologías", key: "add-atributo-por-patologia", parent: "carga-datos" },
    { name: "ControlSeguimiento", key: "controlseguimiento", parent: "carga-datos" },
    { name: "Seguimiento", key: "seguimiento", parent: "carga-datos" },
    { name: "Zonas sanitarias", key: "zonas-sanitarias", parent: "carga-datos" },
    { name: "Zonas geograficas", key: "zonas-geograficas", parent: "carga-datos" },
    { name: "Vacunas", key: "add-vacunas", parent: "carga-datos" },
    { name: "Medicaciones", key: "add-medicaciones", parent: "carga-datos" },
    { name: "Establecimientos de diagnóstico", key: "establecimientos-diagnostico", parent: "carga-datos" },
    { name: "Instituciones de seguimiento de tratamiento", key: "instituciones-seguimiento-tratamiento", parent: "carga-datos" },
    { name: "Evoluciones clínico-terapéuticas", key: "evoluciones-clinico-terapeuticas", parent: "carga-datos" },
    { name: "Sectores y subsectores", key: "sectores-subsectores", parent: "carga-datos" },
    { name: "Vacunación por patología", key: "add-vacunas-por-patologia", parent: "carga-datos" },
    { name: "Medicación por patología", key: "add-medicacion-por-patologia", parent: "carga-datos" },

  // Menú principal: Reglas
  { name: "Reglas", key: "reglas", isMain: true },
    { name: "Gestión de Reglas", key: "gestion-reglas", parent: "reglas" },

  // Menú principal: Listados
  { name: "Listados", key: "listados", isMain: true },
    { name: "Lista de personas", key: "lista-personas", parent: "listados" },

  // Menú principal: Grafos
  { name: "Grafos", key: "grafos", isMain: true },
    { name: "Renderizado de grafos", key: "render-grafos", parent: "grafos" },
    { name: "Ingresar relaciones", key: "ingresar-relaciones", parent: "grafos" },
    { name: "Añadir tipos de relación", key: "tipos-relacion", parent: "grafos" },
    { name: "Agregar fechas de seguimiento", key: "fechas-seguimiento", parent: "grafos" },

  // Menú principal: Informe
  { name: "Informe", key: "informe", isMain: true },

  // Menú principal: G.I.S.
  { name: "G.I.S.", key: "gis", isMain: true },
];

const crudActions = [
  { label: "Ver", key: "read" },
  { label: "Crear", key: "create" },
  { label: "Editar", key: "edit" },
  { label: "Eliminar", key: "delete" },
];

export default function CrearPerfilPage() {
  const [perfilId, setPerfilId] = useState("");
  const [perfiles, setPerfiles] = useState([]);
  const [loadingPerfiles, setLoadingPerfiles] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [permisos, setPermisos] = useState({});
  const [idsPermisoCargados, setIdsPermisoCargados] = useState([]);
  const [catalogoAccesos, setCatalogoAccesos] = useState({});
  const [modulosCatalogo, setModulosCatalogo] = useState(defaultModules);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const loadCatalogo = async () => {
      try {
        const { data } = await api.get("/accesos-por-modulo");
        const mapa = (data || []).reduce((acc, item) => {
          const modulo = String(item.moduloCodigo || "").toLowerCase();
          const acceso = String(item.accesoCodigo || "").toLowerCase();

          if (!modulo || !acceso) {
            return acc;
          }

          if (!acc[modulo]) {
            acc[modulo] = {};
          }

          acc[modulo][acceso] = Number(item.idAccesoPorModulo);
          return acc;
        }, {});

        const modulos = (data || []).reduce((acc, item) => {
          const moduloCodigo = String(item.moduloCodigo || "").toLowerCase();
          let moduloNombre = String(item.moduloNombre || "").trim();

          // Reemplazar 'Graficos' por 'Grafos'
          if (moduloNombre.toLowerCase() === "graficos") {
            moduloNombre = "Grafos";
          }

          if (!moduloCodigo || acc.some((m) => m.key === moduloCodigo)) {
            return acc;
          }

          acc.push({
            key: moduloCodigo,
            name: moduloNombre === "Personas" ? "Listado de Personas" : moduloNombre || moduloCodigo,
          });

          return acc;
        }, []);

        setCatalogoAccesos(mapa);
        // Siempre usar defaultModules para la visualización agrupada
        setModulosCatalogo(defaultModules);
      } catch (error) {
        setCatalogoAccesos({});
        setModulosCatalogo(defaultModules);
        console.error("No se pudo cargar catálogo de accesos por módulo:", error);
      }
    };

    loadCatalogo();
  }, []);

  const loadPerfiles = async () => {
    try {
      setLoadingPerfiles(true);
      const { data } = await api.get("/perfiles");
      setPerfiles(data || []);
    } catch (error) {
      console.error("No se pudieron cargar perfiles:", error);
      setPerfiles([]);
    } finally {
      setLoadingPerfiles(false);
    }
  };

  useEffect(() => {
    loadPerfiles();
  }, []);

  const buildPermisosFromIds = (idsAccesoPorModulo, catalogo) => {
    const idsSet = new Set((idsAccesoPorModulo || []).map((id) => Number(id)));
    const permisosMap = {};

    Object.entries(catalogo || {}).forEach(([modulo, acciones]) => {
      permisosMap[modulo] = {};

      Object.entries(acciones || {}).forEach(([accion, idAccesoPorModulo]) => {
        permisosMap[modulo][accion] = idsSet.has(Number(idAccesoPorModulo));
      });
    });

    return permisosMap;
  };

  const loadPerfilById = async (selectedId) => {
    if (!selectedId) {
      return;
    }

    setPerfilId(String(selectedId));

    try {
      const [perfilResponse, permisosResponse] = await Promise.all([
        api.get(`/perfiles/${selectedId}`),
        api.get(`/perfiles/${selectedId}/permisos`),
      ]);

      setNombre(perfilResponse?.data?.nombre || "");
      setDescripcion(perfilResponse?.data?.descripcion || "");

      const idsAccesoPorModulo = permisosResponse?.data?.idsAccesoPorModulo || [];
      setIdsPermisoCargados(idsAccesoPorModulo);
      setPermisos(buildPermisosFromIds(idsAccesoPorModulo, catalogoAccesos));
    } catch (error) {
      alert("No se pudo cargar el perfil seleccionado");
    }
  };

  const handleNombreChange = async (event) => {
    const valor = event.target.value;
    setNombre(valor);

    if (perfilId) {
      return;
    }

    const nombreNormalizado = String(valor || "").trim().toLowerCase();
    if (!nombreNormalizado) {
      return;
    }

    const perfilExistente = perfiles.find(
      (perfil) => String(perfil.nombre || "").trim().toLowerCase() === nombreNormalizado
    );

    if (perfilExistente?.idPerfil) {
      await loadPerfilById(perfilExistente.idPerfil);
    }
  };

  const handleNuevoPerfil = () => {
    setPerfilId("");
    setNombre("");
    setDescripcion("");
    setPermisos({});
    setIdsPermisoCargados([]);
    setShowForm(true);
  };

  const handleVolverListado = async () => {
    setPerfilId("");
    setNombre("");
    setDescripcion("");
    setPermisos({});
    setIdsPermisoCargados([]);
    setShowForm(false);
    await loadPerfiles();
  };

  const handleEditarDesdeListado = async (idPerfilSeleccionado) => {
    await loadPerfilById(idPerfilSeleccionado);
    setShowForm(true);
  };

  const handleDeletePerfil = async () => {
    if (!perfilId) {
      return;
    }

    const confirmed = window.confirm("¿Seguro que deseas eliminar este perfil? Esta acción no se puede deshacer.");
    if (!confirmed) {
      return;
    }

    try {
      setSaving(true);
      const { data } = await api.delete(`/perfiles/${perfilId}`);
      alert(data?.msg || "Perfil eliminado correctamente");
      await handleVolverListado();

      try {
        await loadPerfiles();
      } catch (error) {
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.msg;
      alert(backendMessage || "No se pudo eliminar el perfil");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (!perfilId || !idsPermisoCargados.length) {
      return;
    }

    setPermisos(buildPermisosFromIds(idsPermisoCargados, catalogoAccesos));
  }, [catalogoAccesos, perfilId, idsPermisoCargados]);

  const handlePermisoChange = (modKey, actionKey) => {
    setPermisos((prev) => ({
      ...prev,
      [modKey]: {
        ...prev[modKey],
        [actionKey]: !prev[modKey]?.[actionKey]
      }
    }));
  };

  const handleSelectAllPermisos = (checked) => {
    const nuevosPermisos = {};
    modulosCatalogo.forEach((mod) => {
      nuevosPermisos[mod.key] = {};
      crudActions.forEach((action) => {
        nuevosPermisos[mod.key][action.key] = checked;
      });
    });
    setPermisos(nuevosPermisos);
  };

  const handleSelectRowPermisos = (modKey, checked) => {
    setPermisos((prev) => ({
      ...prev,
      [modKey]: crudActions.reduce((acc, action) => {
        acc[action.key] = checked;
        return acc;
      }, {})
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      const payload = {
        nombre,
        descripcion,
      };

      const { data } = perfilId
        ? await api.put(`/perfiles/${perfilId}`, payload)
        : await api.post("/perfiles", payload);

      const savedPerfilId = Number(data?.perfil?.idPerfil || perfilId);
      // Filtrar solo submenús (no menús principales)
      const subMenuKeys = defaultModules.filter(m => !m.isMain).map(m => m.key);
      const idsAccesoPorModulo = Object.entries(permisos)
        .filter(([modulo]) => subMenuKeys.includes(modulo))
        .flatMap(([modulo, acciones]) => {
          const accionesMap = acciones || {};
          return Object.entries(accionesMap)
            .filter(([, activo]) => Boolean(activo))
            .map(([accion]) => Number(catalogoAccesos?.[modulo]?.[accion]))
            .filter((id) => Number.isInteger(id) && id > 0);
        });

      // Log para depuración
      console.log("Permisos seleccionados:", permisos);
      console.log("idsAccesoPorModulo enviados:", idsAccesoPorModulo);
      console.log("catalogoAccesos:", catalogoAccesos);
      Object.entries(catalogoAccesos).forEach(([modulo, acciones]) => {
        console.log(`catalogoAccesos[${modulo}]`, acciones);
      });

      if (savedPerfilId > 0) {
        await api.put(`/perfiles/${savedPerfilId}/permisos`, {
          idsAccesoPorModulo,
        });
      }

      alert(data?.msg || (perfilId ? "Perfil actualizado correctamente" : "Perfil creado correctamente"));
      await handleVolverListado();

      try {
        await loadPerfiles();
      } catch (error) {
      }
    } catch (error) {
      const backendMessage = error?.response?.data?.msg;
      alert(backendMessage || "No se pudo crear el perfil");
    } finally {
      setSaving(false);
    }
  };

  const columnasPerfiles = [
    {
      name: "ID",
      selector: (row) => row.idPerfil,
      sortable: true,
      width: "90px",
    },
    {
      name: "Nombre",
      selector: (row) => row.nombre || "-",
      sortable: true,
      grow: 1.3,
    },
    {
      name: "Descripción",
      selector: (row) => row.descripcion || "-",
      sortable: false,
      grow: 2,
      wrap: true,
    },
    {
      name: "Acciones",
      cell: (row) => (
        <button
          type="button"
          onClick={() => handleEditarDesdeListado(row.idPerfil)}
          aria-label="Editar perfil"
          title="Editar perfil"
          style={{
            background: "#2a7cf7",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "6px 10px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AiFillEdit size={18} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "140px",
    },
  ];

  if (!showForm) {
    return (
      <div
        style={{
          background: "#f7f8fa",
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          padding: "32px 24px",
          maxWidth: 1050,
          margin: "40px auto",
          minHeight: "80vh",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 600,
              color: "#2a3a4a",
              margin: 0,
            }}
          >
            Perfiles creados
          </h2>

          <button
            type="button"
            onClick={handleNuevoPerfil}
            style={{
              background: "linear-gradient(90deg, #2a7cf7 0%, #1e4fa1 100%)",
              color: "#fff",
              fontWeight: 600,
              border: "none",
              borderRadius: 8,
              padding: "10px 18px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Nuevo perfil
          </button>
        </div>

        <DataTable
          columns={columnasPerfiles}
          data={perfiles}
          progressPending={loadingPerfiles}
          pagination
          highlightOnHover
          noDataComponent="No hay perfiles creados"
        />
      </div>
    );
  }

  return (
    <div
      style={{
        background: "#f7f8fa",
        borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        padding: "32px 24px",
        maxWidth: 900,
        margin: "40px auto",
        minHeight: "80vh"
      }}
    >
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: 600,
          color: "#2a3a4a",
          marginBottom: 24,
          textAlign: "center"
        }}
      >
        {perfilId ? "Editar perfil" : "Crear nuevo perfil"}
      </h2>

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <button
          type="button"
          onClick={handleVolverListado}
          style={{
            border: "1px solid #d1d5db",
            borderRadius: 8,
            background: "#fff",
            padding: "8px 12px",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          Volver al listado
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 500, color: "#3a4a5a", marginBottom: 8, display: "block" }}>
            Nombre del perfil (sugiere existentes)
          </label>
          <div style={{ display: "flex", gap: 10 }}>
            <input
              type="text"
              list="perfiles-sugerencias"
              value={nombre}
              onChange={handleNombreChange}
              required
              placeholder="Ej: Supervisor, Analista, etc."
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid #d1d5db",
                fontSize: "1rem",
                background: "#fff",
                boxSizing: "border-box"
              }}
            />
            <datalist id="perfiles-sugerencias">
              {perfiles.map((perfil) => (
                <option key={perfil.idPerfil} value={perfil.nombre} />
              ))}
            </datalist>

            {perfilId && (
              <button
                type="button"
                onClick={handleNuevoPerfil}
                style={{
                  border: "1px solid #d1d5db",
                  borderRadius: 8,
                  background: "#fff",
                  padding: "10px 12px",
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                }}
              >
                Nuevo
              </button>
            )}
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 500, color: "#3a4a5a", marginBottom: 8, display: "block" }}>
            Descripción
          </label>
          <textarea
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Describe brevemente el perfil"
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              fontSize: "1rem",
              background: "#fff",
              minHeight: 60,
              resize: "vertical",
              boxSizing: "border-box"
            }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 500, color: "#3a4a5a", marginBottom: 12, display: "block" }}>
            Permisos de acceso
          </label>
          {/* Checkbox seleccionar todos */}
          <div style={{ marginBottom: 12 }}>
            <input
              type="checkbox"
              id="select-all-permisos"
              checked={modulosCatalogo.every(mod => crudActions.every(action => permisos[mod.key]?.[action.key])) && modulosCatalogo.length > 0}
              onChange={e => handleSelectAllPermisos(e.target.checked)}
              style={{ marginRight: 8 }}
            />
            <label htmlFor="select-all-permisos" style={{ fontWeight: 400, color: "#1a1a1a" }}>
              Seleccionar todos
            </label>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {modulosCatalogo.filter(mod => mod.isMain).map((mainMod) => (
              <div key={mainMod.key} style={{ marginBottom: 4 }}>
                <div style={{
                  background: "#dbeafe",
                  borderRadius: 8,
                  padding: "12px 16px",
                  fontWeight: 700,
                  color: "#1e293b",
                  fontSize: "1.08rem",
                  marginBottom: 2,
                  border: "1px solid #b6d4fe"
                }}>
                  {mainMod.name}
                </div>
                {/* Submenús */}
                {modulosCatalogo.filter(sub => sub.parent === mainMod.key).map((subMod) => (
                  <div
                    key={subMod.key}
                    style={{
                      background: "#e9eef5",
                      borderRadius: 8,
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      flexWrap: "wrap",
                      marginLeft: 32,
                      marginTop: 6
                    }}
                  >
                    {/* Checkbox seleccionar fila completa */}
                    <input
                      type="checkbox"
                      id={`select-row-${subMod.key}`}
                      checked={crudActions.every(action => permisos[subMod.key]?.[action.key])}
                      onChange={e => handleSelectRowPermisos(subMod.key, e.target.checked)}
                      style={{ marginRight: 8 }}
                    />
                    <label htmlFor={`select-row-${subMod.key}`} style={{ minWidth: 100, fontWeight: 500, color: "#1a1a1a" }}>
                      {subMod.name}
                    </label>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      {crudActions.map((action) => (
                        <div
                          key={action.key}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            fontWeight: 400,
                            cursor: "pointer",
                            background: "#fff",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            padding: "4px 8px"
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={!!(permisos[subMod.key]?.[action.key])}
                            onChange={() => handlePermisoChange(subMod.key, action.key)}
                            style={{ cursor: "pointer" }}
                          />
                          {action.label}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                {/* Si el menú principal no tiene submenús, mostrarlo como opción seleccionable */}
                {modulosCatalogo.filter(sub => sub.parent === mainMod.key).length === 0 && (
                  <div
                    style={{
                      background: "#e9eef5",
                      borderRadius: 8,
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      flexWrap: "wrap",
                      marginLeft: 32,
                      marginTop: 6
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`select-row-${mainMod.key}`}
                      checked={crudActions.every(action => permisos[mainMod.key]?.[action.key])}
                      onChange={e => handleSelectRowPermisos(mainMod.key, e.target.checked)}
                      style={{ marginRight: 8 }}
                    />
                    <label htmlFor={`select-row-${mainMod.key}`} style={{ minWidth: 100, fontWeight: 500, color: "#1a1a1a" }}>
                      {mainMod.name}
                    </label>
                    <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                      {crudActions.map((action) => (
                        <div
                          key={action.key}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            fontWeight: 400,
                            cursor: "pointer",
                            background: "#fff",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            padding: "4px 8px"
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={!!(permisos[mainMod.key]?.[action.key])}
                            onChange={() => handlePermisoChange(mainMod.key, action.key)}
                            style={{ cursor: "pointer" }}
                          />
                          {action.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
          <button
            type="submit"
            disabled={saving}
            style={{
              background: "linear-gradient(90deg, #2a7cf7 0%, #1e4fa1 100%)",
              color: "#fff",
              fontWeight: 600,
              border: "none",
              borderRadius: 8,
              padding: "12px 32px",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s",
              width: "100%"
            }}
          >
            {saving ? "Guardando..." : perfilId ? "Actualizar perfil" : "Guardar perfil"}
          </button>

          {perfilId && (
            <button
              type="button"
              disabled={saving}
              onClick={handleDeletePerfil}
              style={{
                background: "#dc3545",
                color: "#fff",
                fontWeight: 600,
                border: "none",
                borderRadius: 8,
                padding: "12px 20px",
                fontSize: "1rem",
                cursor: "pointer",
                whiteSpace: "nowrap"
              }}
            >
              Eliminar perfil
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
